import React from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, Legend } from 'recharts';

const COLORS = ['#6366f1', '#38bdf8', '#22c55e', '#f59e0b', '#ef4444', '#a855f7'];

export default function AiUsageBreakdowns({ byApp, byUseCase, loading }) {
  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>BY APPLICATION</Typography>
        {loading
          ? <Skeleton variant="rectangular" height={140} />
          : (
            <ResponsiveContainer width="100%" height={140}>
              <BarChart data={byApp} layout="vertical" margin={{ left: 60 }}>
                <XAxis type="number" tick={{ fontSize: 11 }} />
                <YAxis type="category" dataKey="app" tick={{ fontSize: 11 }} width={80} />
                <Tooltip />
                <Bar dataKey="calls" fill="#6366f1" radius={[0, 2, 2, 0]} />
              </BarChart>
            </ResponsiveContainer>
          )
        }
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>BY USE CASE</Typography>
        {loading
          ? <Skeleton variant="rectangular" height={140} />
          : (
            <ResponsiveContainer width="100%" height={200}>
              <PieChart margin={{ top: 5, bottom: 5, left: 0, right: 0 }}>
                <Pie data={byUseCase} dataKey="calls" nameKey="use_case" cx="35%" outerRadius={70} label={false}>
                  {(byUseCase || []).map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Legend iconSize={10} iconType="circle" layout="vertical" align="right" verticalAlign="middle" wrapperStyle={{ fontSize: 11 }} formatter={(v) => v} />
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          )
        }
      </Grid>
    </Grid>
  );
}
